import { TAO_KOE } from './../libs';

class FactfinderContentClass {
	results = {};

	constructor( containerEl ) {
		this.containerEl = containerEl;

		document.addEventListener( 'update.ff', async( ev ) => {
			await this.onUpdate( ev.detail.data );
		} );
	}

	getBanner( innerHTML, className = '' ) {
		// Create dummy.
		const dummyEl = document.createElement( 'div' );
		dummyEl.innerHTML = innerHTML;

		// Get Banner.
		const bannerEl = dummyEl.firstElementChild;
		if ( className && bannerEl ) {
			bannerEl.classList.add( className );
		}
		return bannerEl;
	}

	async fetchBanners( params ) {
		if ( this.results[ params.toString() ] ?? null ) {
			return await this.results[ params.toString() ];
		}

		const result = fetch( `/index.php?${ params.toString() }` ).then( ( res ) => res.json() );
		this.results[ params.toString() ] = result;
		return await result;
	}

	onUpdate( resultData ) {
		const params = new URLSearchParams( {
			'cl': 'ff_web_component',
			'fnc': 'getTeasers',
		} );

		return this.fetchBanners( params ).then( ( { listbanners, broadListBanners } ) => {
			// Remove previously added banners.
			this.containerEl.querySelectorAll( '.en_mdl_productlisttile' ).forEach( ( tileEl ) => tileEl.remove() );
			this.containerEl.querySelectorAll( '.en_mdl_productlistteaser' ).forEach( ( teaserEl ) => teaserEl.remove() );

			// Add Listbanners.
			const page = parseInt( Math.abs( resultData.paging.currentPage - 1 ) % 2 ) || 0;
			const positions = [ 11, 45 ];
			Object.keys( listbanners ).slice( page * 2, ( page + 1 ) * 2 ).forEach( ( idx ) => {
				const bannerEl = this.getBanner( listbanners[ idx ], 'en_mdl_productlisttile' );
				if ( bannerEl ) {
					this.insertBannerAtPosition( bannerEl, positions[ idx % 2 ] );
				}
			} );

			// Add Broadlistbanners.
			Object.keys( broadListBanners ).forEach( ( idx ) => {
				const bannerEl = this.getBanner( broadListBanners[ idx ], 'en_mdl_productlistteaser' );
				if ( bannerEl ) {
					this.insertBannerAtPosition( bannerEl, ( idx * 6 ) );
				}
			} );
		} ).finally( () => {
			this.containerEl.dispatchEvent( new CustomEvent( 'aftersearch_content_injected.sl', { bubbles: true } ) );
		} );
	}

	insertBannerAtPosition( bannerEl, position ) {
		// Get all Elements in list to get correct index.
		const productAndTileEls = this.containerEl.querySelectorAll( 'article.en_mdl_product, figure.en_mdl_productlisttile' );
		const targetEl = productAndTileEls[ position ] ?? null;
		if ( targetEl ) {
			targetEl.insertAdjacentElement( 'beforebegin', bannerEl );

			// Trigger lazyload, so we can initialise click handler again and stuff.
			bannerEl.dispatchEvent( new CustomEvent( 'lazyload.tao', { bubbles: true } ) );
		}
	}
}

// Init.
TAO_KOE.ready( 'factfinder-content.js', () => {
	const productListEls = document.querySelectorAll( '.en_mdl_products.en_mdl_products--ff' );
	productListEls.forEach( ( productListEl ) => {
		productListEl.KOE_FACTFINDER_CONTENT ??= new FactfinderContentClass( productListEl );
	} );
} );

// Export.
export default FactfinderContentClass;
